import { Alert, Box, Collapse, Paper, Stack, Typography } from "@mui/material";
import TitleForm from "../Common/TitleForm";
import Actions from "../Common/Actions";
import { useState } from "react";
import useUpdateSection from "../Hooks/useUpdateSection";
import useDeleteSection from "../Hooks/useDeleteSection";
import SectionForm from "./SectionForm";
import sectionTypes from "../../../config/sectionTypes";
import Draggable from "../Common/Draggable";
import { txt } from "../../../services/translation";

export default function Section({data}){

    const [titleForm, setTitleForm] = useState(data.edit ? true : false)
    const [form, setForm] = useState(false)

    const [drag, setDrag] = useState(false)

    const updateSection = useUpdateSection()
    const deleteSection = useDeleteSection()

    const handleNewTitle = title => {
        setTitleForm(false)
        updateSection({...data, title})
    }

    const type = sectionTypes.find(t => t.id === data.type?.id)

    return <>

        <Draggable id={data.id} data={{...data, isSection: true}} disabled={!drag}>

            <Stack sx={{pl: 5}}>

                <Paper
                    variant='outlined'
                    sx={{p: 1}}
                    data-id={data.id}
                    data-rank={data.rank}
                >
                    {titleForm ?
                        <TitleForm
                            title={data.title}
                            onSubmit={handleNewTitle}
                            onCancel={() => setTitleForm(false)}
                        />
                        :
                        <Stack direction='row' alignItems='center' spacing={1}>

                            {type?.icon}

                            <Box sx={{flex:1}} onClick={() => setTitleForm(true)}>
                                {data.title ? 
                                    <Typography>{data.title}</Typography>
                                    :
                                    <Alert severity='warning'>{txt('addTitle')}</Alert>
                                }
                            </Box>

                            <Actions
                                onDelete={() => deleteSection(data.id)}
                                onEdit={() => setForm(true)}
                                onDrag={() => setDrag(true)}
                                onDrop={() => setDrag(false)}
                            />
                        </Stack>
                    }

                    <Collapse direction="down" in={form} mountOnEnter unmountOnExit>
                        <SectionForm
                            section={data} 
                            onSubmit={() => setForm(false)}
                            onCancel={() => setForm(false)}
                        />
                    </Collapse>

                </Paper>

            </Stack>

        </Draggable>

    </> 
}